let $store;
export function waitPlugin(store) {
  $store = store;
}
export function waitFor(getterName, timeout) {
  return new Promise((resolve, reject) => {
    if ($store.getters[getterName]) return resolve();
    let unwatch = $store.watch(
      (state, getters) => getters[getterName],
      value => {
        if (value) {
          unwatch();
          resolve();
        }
      }
    );
    setTimeout(() => {unwatch(); reject('time out')}, timeout);
  })
}



// WEBPACK FOOTER //
// ./src/store/wait.js